const lang = {
  language: "简体中文",
  lang: "zh-CN",
  head: {
    home: "首页",
    blog: "博客",
    about: "关于我",
    login: "登录"
  },
  about: {
    title: "自我介绍",
    content: `忠实诚信,讲原则，做事情始终坚持有始有终，追求更好；<br />
    肯学习,有问题不逃避,愿意虚心向他人学习；<br />
    会用100%的热情和精力投入到工作中，脚踏实地；<br />
    喜欢团队工作，有较强的团队精神,工作积极进取。
    `
  },
  home: {
    professional: {
      title: "我的职业",
      details: {
        text: "我是一个程序员.",
        desc: "会用100%的热情和精力投入到工作中，脚踏实地.",
        specialty: {
          focus: {
            text: "专长",
            desc: "Java, .Net, 数据库, 前端."
          },
          study: {
            text: "学习",
            desc: "肯学习,有问题不逃避,愿意虚心向他人学习."
          },
          team: {
            text: "团队工作",
            desc: "肯学习,有问题不逃避,愿意虚心向他人学习."
          }
        }
      }
    },
    project: {
      title: "项目经验"
    },
    contact: {
      title: "联系方式"
    }
  },
  foot: {
    copyright: "版权所有",
    record: "皖ICP备18013678号"
  },
  pager: {
    prev: "上一页",
    next: "下一页"
  }
};

export default lang;



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js